import React, { forwardRef, useEffect, useState } from "react";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";
import { LEGAL_LANGUAGES, fetchLegalDocument, formatLegalDate, legalCopy, legalLanguage } from "../../../utils/legalDocuments";
import "./LegalDocument.css";

export const LegalDocumentMeta = ({ document }) => {
  const copy = legalCopy(document?.language);
  const effective = formatLegalDate(document?.effective_date, document?.language);
  const reviewed = formatLegalDate(document?.reviewed_on, document?.language);
  if (!effective && !reviewed && !document?.version) return null;
  return (
    <p className="kz-legal-doc__meta">
      {effective && <span>{copy.effective} {effective}</span>}
      {reviewed && <span>{copy.lastReviewed} {reviewed}</span>}
      {document?.version && <span>{copy.version} {document.version}</span>}
    </p>
  );
};

export const LegalFallbackNotice = ({ document }) => {
  const requested = document?.requested_language;
  if (!requested || requested === document?.language) return null;
  return <p className="kz-legal-doc__fallback">{legalCopy(requested).fallback(legalLanguage(requested).name)}</p>;
};

export const LegalLanguageSelect = ({ value, onChange, className = "" }) => {
  return (
    <label className={`kz-legal-doc__language ${className}`.trim()}>
      <span className="kz-legal-doc__sr">{legalCopy(value).language}</span>
      <select value={value} onChange={(event) => onChange(event.target.value)} aria-label={legalCopy(value).language}>
        {LEGAL_LANGUAGES.map((language) => (
          <option key={language.code} value={language.code}>
            {language.name}
          </option>
        ))}
      </select>
    </label>
  );
};

export const LegalDocumentBody = forwardRef(({ html, className = "", lang }, ref) => (
  <div
    ref={ref}
    lang={lang}
    className={`kz-legal-doc ${className}`.trim()}
    dangerouslySetInnerHTML={{ __html: sanitizeHtml(html || "") }}
  />
));

const LegalDocumentContent = ({ kind, footer = null }) => {
  const [language, setLanguage] = useState("en");
  const [document, setDocument] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setFailed(false);
    fetchLegalDocument(kind, language)
      .then((data) => active && setDocument(data))
      .catch(() => active && setFailed(true));
    return () => {
      active = false;
    };
  }, [kind, language]);

  if (failed) {
    return <p className="kz-legal-doc__status">{legalCopy(language).loadFailed}</p>;
  }
  if (!document) {
    return <p className="kz-legal-doc__status">{legalCopy(language).loading}</p>;
  }
  return (
    <div className="kz-legal-doc__modal">
      <div className="kz-legal-doc__toolbar">
        <LegalDocumentMeta document={document} />
        <LegalLanguageSelect value={language} onChange={setLanguage} />
      </div>
      <LegalFallbackNotice document={document} />
      <LegalDocumentBody html={document.html} lang={document.language} />
      {footer}
    </div>
  );
};

export default LegalDocumentContent;
